module.exports = __webpack_public_path__ + "img/Logotipo_Negativo.168101d8.png";